/**
 * @type {import('@mui/material').ColorObject} - Colors used in whole website.
 */
const COLORS = {
    // genesis grays
    gray100: '#FBFBFC',
    gray150: '#FAF9FA',
    gray200: '#F6F5F6',
    gray250: '#EDEBEE',
    gray300: '#DBD7DD ',
    gray400: '#C8C2CB ',
    gray500: '#B6AEBA ',
    gray550: '#888B8D ',
    gray600: '#A49AA9 ',
    gray700: '#928698 ',
    gray800: '#807286 ',
    gray900: '#64536D ',
    gray950: '#5B4964 ',
    gray1000: '#523F5C ',

    // genesis colors
    sunset: '#DD1D78',
    sunset30: '#9B1454',
    purpleTaupe: '#493552',
    heather: '#493553',
    heather80: '#6D5D75',
    graniteGray: '#6A5971',
    oat: '#F5EBDA',
    caribbeanGreen: '#00C389',
    bangladeshGreen: '#007552',
    purple: '#800080',
    white: '#FFFFFF',
    black: ' #000000',
    aliceBlue: '#E8F4FE',
    jetBlack: '#323435',
    redOrange: '#F44336',
    cherryVelvet: '#E40046',
};

/**
 * @type {object} - BOX_SHADOW's used in whole website
 */

const BOX_SHADOW = {
    boxShadow1:
        '#888b8d33 0px 6px 6px -3px, #888b8d24 0px 10px 14px 1px, #888b8d33 0px 4px 18px 3px',
    boxShadow1Lite: '#d111c91f',
    boxShadow1Medium: '#d111c924',
    boxShadow1Dark: '#d111c933',
    boxShadow1Darkest: '#d111c966',
    boxShadow2Lite: '#888b8d1f',
    boxShadow2Medium: '#888b8d24',
    boxShadow2Dark: '#888b8d33',
    boxShadow3: '#ffffff00',
    boxShadow3Lite: '#ffffff9e',
    boxShadow3Medium: '#ffffffcc',
    boxShadow3Dark: '#ffffffe6',
    boxShadow4: '#00000000',
    boxShadow4Lite: '#00000033',
    boxShadow4Medium: '#0000004d',
    boxShadow4Dark: '#000000b3',
    boxShadow5Medium: '#00000082',
};

export { COLORS, BOX_SHADOW };
